import moment from "moment";
import * as XLSX from "xlsx";
const { utils } = XLSX;

const ExportAllToExcel = async (data: any[], fileName: string) => {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      return { status: false, message: "Data is empty or not in the correct format." };
    }

    // Define custom headers
    const headers = [
      "Date",
      "Activity ID",
      "Activity Name",
      "Total Amount",
      // "Total Tickets" // removed Total Tickets
    ];

    const dateMap = new Map<string, any[]>();

    data.forEach((activity) => {
      activity.by_date.forEach((dateItem: any) => {
        const date = moment(dateItem.date).format("YYYY-MM-DD");
        if (!dateMap.has(date)) {
          dateMap.set(date, []);
        }
        dateMap.get(date)!.push({
          date: date,
          activity_id: activity.activity_id,
          activity_name: activity.activity_name,
          total_amount: dateItem.total_amount,
          // total_tickets: dateItem.total_tickets // removed Total Tickets
        });
      });
    });

    const sortedDates = Array.from(dateMap.keys()).sort();

    const filteredData: any[] = [];

    sortedDates.forEach((date) => {
      const activitiesForDate = dateMap.get(date)!;
      activitiesForDate.sort((a, b) => a.activity_name.localeCompare(b.activity_name));

      activitiesForDate.forEach((item) => {
        filteredData.push([
          item.date,
          item.activity_id,
          item.activity_name,
          item.total_amount,
          // item.total_tickets // removed Total Tickets
        ]);
      });

      const dateTotalAmount = activitiesForDate.reduce((sum, item) => sum + item.total_amount, 0);
      // const dateTotalTickets = activitiesForDate.reduce((sum, item) => sum + item.total_tickets, 0); // removed Total Tickets
      filteredData.push([
        "",
        "",
        `Subtotal for ${date}`, 
        dateTotalAmount,
        // dateTotalTickets // 
      ]);
    });

    const grandTotalAmount = data.reduce((sum, item) => sum + item.total_amount, 0);
    // const grandTotalTickets = data.reduce((sum, item) => sum + item.total_tickets, 0); // removed Total Tickets

    filteredData.push([
      "",
      "",
      "Grand Total",
      grandTotalAmount,
      // grandTotalTickets // 
    ]);

    const aoa = [headers, ...filteredData];

    const ws = utils.aoa_to_sheet(aoa);

    const headerCells = ["A1", "B1", "C1", "D1" /* , "E1" */]; 
    headerCells.forEach((cell) => {
      ws[cell].s = {
        fill: { patternType: "solid", fgColor: { rgb: "ADD8E6" } },
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
    });

    filteredData.forEach((row, index) => {
      if (row[2].includes("Subtotal") || row[2] === "Grand Total") {
        const rowNum = index + 2;
        const cells = [`C${rowNum}`, `D${rowNum}` /* , `E${rowNum}` */]; 
        cells.forEach((cell) => {
          if (ws[cell]) {
            ws[cell].s = {
              font: { bold: true },
              fill: {
                patternType: "solid",
                fgColor: { rgb: row[2] === "Grand Total" ? "FFFF99" : "E6E6E6" }
              },
              alignment: { horizontal: "right" }
            };
          }
        });
      }
    });

    ws["!cols"] = [
      { wch: 15 },
      { wch: 15 },
      { wch: 25 },
      { wch: 15 },
      // { wch: 15 }, //
    ];

    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Activity Report");

    const str = fileName + "_" + moment().format("DD_MM_YYYY");
    const timestamp = moment().unix();
    const fullFileName = `${str}_${timestamp}.xlsx`;

    XLSX.writeFile(wb, fullFileName, { bookType: "xlsx", type: "binary" });

    return { status: true, message: "Export successful" };
  } catch (err) {
    console.error("Export error:", err);
    return { status: false, message: "Error exporting data" };
  }
};

export { ExportAllToExcel };
